module.exports = __webpack_public_path__ + "img/login_password_changed_en.6b226738.png";